import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { graphql, compose } from 'react-apollo';
import GET_FORGOT_PASSWORD from '../../../graphql/ForgotPassword';
import CHANGE_PASSWORD_WITH_CODE from '../../../graphql/ChangePasswordWithCode';

class ForgotPasswordPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      code: '',
      password: '',
      passwordConfirmation: '',
      error: false,
      info: false,
    };
  }

  recoverPassword = (e) => {
    e.preventDefault();
    this.setState({
      error: false,
      info: false,
    });
    this.props.forgotPassword({
      variables: {
        email: this.state.email,
      },
    })
      .then((res) => {
        if (res.data.forgotPassword.success) {
          this.setState({
            info: 'Email enviado con éxito',
          });
        } else {
          this.setState({
            error: 'Ocurrió un error recuperando la contraseña',
          });
        }
      })
      .catch((err) => {
        this.setState({ error: 'Ocurrió un error recuperando la contraseña' });
      });
  };

  validateCodeAndChangePassword = (e) => {
    e.preventDefault();
    const { code, password, passwordConfirmation } = this.state;
    this.setState({
      error: false,
      info: false,
    });
    if (code.length === 0) {
      this.setState({
        error: 'Codigo inválido',
      });
      return;
    }
    if (password.length < 6) {
      this.setState({
        error: 'La contraseña debe tener al menos 6 carácteres',
      });
      return;
    }
    if (password !== passwordConfirmation) {
      this.setState({
        error: 'Las contraseñas no coinciden',
      });
      return;
    }
    this.props.changePasswordWithCode({
      mutation: CHANGE_PASSWORD_WITH_CODE,
      variables: {
        code,
        password,
      },
    })
      .then((res) => {
        if (res.data.changePasswordWithCode.success) {
          this.setState({
            info: res.data.changePasswordWithCode.message,
          });
        } else {
          this.setState({
            error: res.data.changePasswordWithCode.message,
          });
        }
      })
      .catch(() => {
        this.setState({ error: 'Ocurrió un error recuperando la contraseña' });
      });
  };

  render() {
    const { error, info } = this.state;
    return (
      <div className="login__page">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="form-content-box">
                <div className="details">
                  <Link to="/">
                    <img
                      src="/img/logos/logo-2.png"
                      className="cm-logo"
                      alt="black-logo"
                    />
                  </Link>
                  <h3>Recuperar contraseña</h3>
                  <form onSubmit={this.recoverPassword}>
                    {error && <p className="red">{error}</p>}
                    {info && <p className="green">{info}</p>}
                    <div className="form-group">
                      <input
                        type="email"
                        name="email"
                        className="input-text"
                        placeholder="Correo electrónico"
                        onChange={e => this.setState({ email: e.target.value })}
                      />
                    </div>
                    <div className="form-group">
                      <button
                        onClick={e => this.recoverPassword(e)}
                        className="button-md button-theme btn-block"
                      >
                        Enviar correo
                      </button>
                    </div>
                    <br /> Ingresa el código que enviamos a tu correo y una nueva contraseña
                    <br />
                    <br />
                    <div className="form-group">
                      <input
                        type="text"
                        name="code"
                        className="input-text"
                        placeholder="Código recuperación"
                        onChange={e => this.setState({ code: e.target.value })}
                      />
                    </div>
                    <div className="form-group">
                      <input
                        type="password"
                        name="Password"
                        className="input-text"
                        placeholder="Contraseña"
                        onChange={e =>
                          this.setState({ password: e.target.value })
                        }
                      />
                    </div>
                    <div className="form-group">
                      <input
                        type="password"
                        name="Password"
                        className="input-text"
                        placeholder="Escriba nuevamente la contraseña"
                        onChange={e =>
                          this.setState({
                            passwordConfirmation: e.target.value,
                          })
                        }
                      />
                    </div>
                    <div className="form-group">
                      <button
                        onClick={e => this.validateCodeAndChangePassword(e)}
                        className="button-md button-theme btn-block"
                      >
                        Cambiar contraseña
                      </button>
                    </div>
                    <Link to="/">
                      <div className="form-group">Volver al inicio</div>
                    </Link>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ForgotPasswordPage.defaultProps = {};

export default compose(
  graphql(GET_FORGOT_PASSWORD, {
    name: 'forgotPassword',
  }),
  graphql(CHANGE_PASSWORD_WITH_CODE, {
    name: 'changePasswordWithCode',
  }),
)(ForgotPasswordPage);



// WEBPACK FOOTER //
// ./src/containers/General/ForgotPasswordPage/index.js